import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import moment from 'moment-timezone'
import store from '@/store'
import router from '@/router'
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)

  const toast = useToast()

  store.dispatch('tenant/getAll');
  store.dispatch('unit/getAll', { with: 'router:id,id_tenant' });
  store.dispatch("time_zone/getAll");
  store.dispatch('center/getAll');
  store.dispatch('sector/getAll');

  const tenantOptions = computed(() => store.getters['tenant/getSelectedItems']);
  const unitOptions = computed(() => store.getters['unit/getSelectedItems']);
  const centerOptions = computed(() => store.getters['center/getSelectedItems']);
  const sectorOptions = computed(() => store.getters['sector/getSelectedItems'])

  const masterAccountFilter = ref(null);
  const tenantFilter = ref(null);
  const centerFilter = ref(null);
  const sectorFilter = ref(null);

  /* if (router.currentRoute.params.id_tenant)
    tenantFilter.value = parseInt(router.currentRoute.id_tenant) */

  const tableColumns = [
    { label: 'pacom.status', key: 'status' },
    { label: 'pacom.masterAccount', key: 'master_account.username' },
    { label: 'pacom.name', key: 'name', sortable: true },
    { label: 'pacom.units', key: 'unit.description'},
    { label: 'pacom.center', key: 'center.name'},
    { label: 'pacom.sector', key: 'sector.name'},
    { label: 'pacom.timeZone', key: 'time_zone' },
  ]

  if (ability.can('update', 'PacomSites') == true || ability.can('delete', 'PacomSites') == true) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const masterAccounts = ref([]);
  const site = ref({});

  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const timezoneOptions = computed(() => store.getters["time_zone/getSelectedItems"]);

  const fetchList = (ctx, callback) => {
    store.dispatch('pacom_sites/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      masterAccount: masterAccountFilter.value,
      tenant: tenantFilter.value,
      center: centerFilter.value,
      sector: sectorFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const fetchMasterAccounts = () => {
    store.dispatch('pacom_master_accounts/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      isList: true
    })
      .then(response => {
        masterAccounts.value = response.data;
      })
      .catch(() => {
        masterAccounts.value = []

        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage,], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  // filters counter ============================
  const filters = ref({});
  const filtersCount = useFilterCounter(filters);
  const buildFilters = () => {
    filters.value = {
      masterAccount: masterAccountFilter.value,
      tenant: tenantFilter.value,
      center: centerFilter.value,
      sector: sectorFilter.value
    }

    refetchData();
  }
  const clearSearchFilters = () => {
    masterAccountFilter.value = null;
    tenantFilter.value = null;
    centerFilter.value = null;
    sectorFilter.value = null;

    buildFilters();
  }
  // ============================================

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,
    fetchMasterAccounts,
    masterAccounts,

    tenantOptions,
    masterAccountFilter,
    tenantFilter,
    centerFilter,
    sectorFilter,
    timezoneOptions,
    unitOptions,
    centerOptions,
    sectorOptions,


    refetchData,

    filtersCount,
    buildFilters,
    clearSearchFilters,
  }
}
